import $ from 'jquery';
import { getState } from '~src/state';
import { editorConfig } from '~config';
import { setSvgColor } from '../ui';

export const updateUndoRedoControls = () => {
  const currentPageIndex = getState('currentPageIndex');
  const currentHistoryIndex = getState(
    `currentHistoryIndex[${currentPageIndex}]`,
    0
  );
  const history = getState(`history[${currentPageIndex}]`, []);
  const totalChangesSinceLastSave = getState('totalChangesSinceLastSave');

  if (
    history.length <= 0 ||
    currentHistoryIndex <= 0 ||
    totalChangesSinceLastSave <= 0
  ) {
    setSvgColor('#editor-menu-undo', editorConfig.styles.inactiveControlColor);
    $('#editor-menu-undo').attr('disabled', 'disabled');
  } else {
    setSvgColor('#editor-menu-undo', editorConfig.styles.activeControlColor);
    $('#editor-menu-undo').removeAttr('disabled');
  }

  if (
    (history.length > 0 && history.length - 1 <= currentHistoryIndex) ||
    totalChangesSinceLastSave <= 0
  ) {
    setSvgColor('#editor-menu-redo', editorConfig.styles.inactiveControlColor);
    $('#editor-menu-redo').attr('disabled', 'disabled');
  } else {
    setSvgColor('#editor-menu-redo', editorConfig.styles.activeControlColor);
    $('#editor-menu-redo').removeAttr('disabled');
  }
};
